import type { ReactNode } from 'react'
import type { AsHeadlessType } from './common-list-option'
import CommonListOption from './common-list-option'
import type { DataInterface, ExtendedDataType, GroupDataInterface } from './editable-form-select'

interface BaseListOptionsProps<T extends ExtendedDataType> {
  data?: T[]
  value?: DataInterface<T>['id']
  getOptionDataAttribute?: (value?: string) => void
  group?: GroupDataInterface
  optionIconRenderer?: (data?: T) => ReactNode | undefined
  as: AsHeadlessType
}

function BaseListOptions<T extends ExtendedDataType>({
  data,
  value,
  getOptionDataAttribute,
  group,
  optionIconRenderer,
  as,
}: BaseListOptionsProps<T>): ReactNode {
  const filteredItems = group ? data?.filter(item => item.group === group.id) : data
  const isGroupTitleVisible = group && filteredItems && filteredItems.length > 0

  return (
    <>
      {isGroupTitleVisible && (
        <div className="flex h-6 shrink-0 items-center border border-t-0 border-text-secondary/30">
          <span className="px-1.5 font-bold text-text-primary">{group.label}</span>
        </div>
      )}
      {filteredItems?.map(item => (
        <CommonListOption
          item={item}
          key={item.id}
          value={value}
          getOptionDataAttribute={getOptionDataAttribute}
          optionIconRenderer={optionIconRenderer}
          as={as}
        />
      ))}
    </>
  )
}

export default BaseListOptions
